import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

const Layout = () => {
  return (
    <div className="min-h-screen flex flex-col bg-[#f8fafc] font-sans antialiased text-gray-900">
      <Header />
      <main className="flex-grow flex flex-col w-full">
        {/* The Outlet renders the current route's component */}
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;